import { CONTACT_METHOD_TYPE } from '../constants/addPersonFormConstants';
import { NON_DIGITS_REGEX } from '../../shared/constants/regex';
import { DEFAULT_VALUES } from '../constants/personContactFormConstants';

export const mapRowToFormValues = (row) =>
  row
    ? {
        ContactMethodType: row.ContactMethod || '',
        ContactType: row.MethodType || '',
        ContactInfo: row.Info || '',
        IsDefaultContact: Boolean(row.IsDefault),
        ContactNotes: row.Notes || '',
      }
    : DEFAULT_VALUES;

export const buildPlacePhoneFields = (contactMethod, info) => {
  const empty = { PhoneNumber: null, AreaCode: null, Extension: null };
  if (contactMethod !== CONTACT_METHOD_TYPE.PHONE || !info) return empty;

  const digits = info.replace(NON_DIGITS_REGEX, '');
  if (digits.length < 10) return empty;

  return {
    AreaCode: Number(digits.slice(0, 3)),
    PhoneNumber: Number(digits.slice(3, 10)),
    Extension: digits.slice(10) || null,
  };
};
